import { render, staticRenderFns } from "./OrgHome.vue?vue&type=template&id=5a1a66f0&scoped=true&"
import script from "./OrgHome.vue?vue&type=script&lang=js&"
export * from "./OrgHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1a66f0",
  null
  
)

export default component.exports